<script>
export default {
  data() {
    return {
      currentStep: 1,
    };
  },
  methods: {
    setStepper(num) {
      this.currentStep = num;
    },
    nextStep() {
      this.currentStep = Number(this.currentStep) + Number(1);
    },
    previousStep() {
      this.currentStep = Number(this.currentStep) - Number(1);
    },
  },
};
</script>
